import {
    organizationUserRolesInOrder,
    OrganizationUserRole,
} from "@common/userOrganizationRoles";

export type ValidateError = string;
export type ValidateResult = null | ValidateError;

export function hasAtLeastOrganizationRole(
    actingUserRole: OrganizationUserRole,
    requiredRole: OrganizationUserRole,
) {
    return (
        organizationUserRolesInOrder.indexOf(actingUserRole) <=
        organizationUserRolesInOrder.indexOf(requiredRole)
    );
}
